import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { CreateSeatDto } from '.././../../dtos/create-show.dto';
import { SeatType } from '../../../enums/seat-type.enum';

@Component({
  selector: 'app-show-third-step',
  templateUrl: './show-third-step.component.html',
  styleUrls: ['./show-third-step.component.scss']
})
export class ShowThirdStepComponent implements OnInit {
  @Input() thirdFormGroup: FormGroup = this.fb.group({});


  rowsSelect: Array<{ value: string, label: string }> = Array(
    { value: 'A', label: 'Fileira A' }, { value: 'B', label: 'Fileira B (A - B)' },
    { value: 'C', label: 'Fileira C (A - C)' }, { value: 'D', label: 'Fileira D (A - D)' },
    { value: 'E', label: 'Fileira E (A - E)' }, { value: 'F', label: 'Fileira F (A - F)' },
    { value: 'G', label: 'Fileira G (A - G)' }, { value: 'H', label: 'Fileira H (A - H)' },
    { value: 'I', label: 'Fileira I (A - I)' }, { value: 'J', label: 'Fileira J (A - J)' }
  );

  seats: CreateSeatDto[][] = [];
  seatsSelected: CreateSeatDto[] = []

  select: Array<{ index: number, seat: CreateSeatDto }> = [];

  cleanSeats: boolean = false;

  constructor(
    private readonly fb: FormBuilder,
  ) { }

  ngOnInit(): void {
    if (this.thirdFormGroup.controls['seats'].value !== ''
      && this.thirdFormGroup.controls['seats'].value !== null
      && this.thirdFormGroup.controls['seats'].value !== undefined) {
      this.updateSeatsArray();
    }
  }

  updateSeatsArray() {
    let index = 0;
    this.seats = this.thirdFormGroup.controls['seats'].value;
    for (let i = 0; i < this.seats.length; i++) {
      for (let j = 0; j < this.seats[i].length; j++) {
        if (this.seats[i][j].available && this.seats[i][j].type !== SeatType.DEFAULT) {
          this.select.push({ index: index, seat: this.seats[i][j] });
          this.seats[i][j].priority = true;
          this.seatsSelected.push(this.seats[i][j]);
          index++;
        }
      }
    }
  }

  createSeatsArray() {
    this.seats = [];
    this.seatsSelected = [];
    this.select = []
    if (this.thirdFormGroup.controls['column'].value !== '' && this.thirdFormGroup.controls['row'].value !== '') {
      for (let i = 0; i < this.rowsSelect.length; i++) {
        var seatArray = []
        for (let j = 0; j < this.thirdFormGroup.controls['column'].value; j++) {
          var seat: CreateSeatDto = {
            column: j + 1,
            row: this.rowsSelect[i].value,
            priority: false,
            available: true,
            type: SeatType.DEFAULT
          }
          seatArray.push(seat);
        }
        this.seats.push(seatArray);
        if (this.rowsSelect[i].value === this.thirdFormGroup.controls['row'].value) {
          break;
        }
      }
    }
    this.thirdFormGroup.controls['seats'].setValue(this.seats);
    this.cleanSeats = true;
  }

  onSelectSeat(index: number, seatSelect: CreateSeatDto) {
    for (let i = 0; i < this.seats.length; i++) {
      for (let j = 0; j < this.seats[i].length; j++) {
        if (this.seats[i][j].column === seatSelect.column && this.seats[i][j].row === seatSelect.row) {
          this.seats[i][j].priority = true;
          this.seats[i][j].type = seatSelect.type;
          this.select.push({ index: index, seat: seatSelect })
          break;
        }
      }
    }

    for (let i = 0; i < this.seats.length; i++) {
      for (let j = 0; j < this.seats[i].length; j++) {
        for (let k = 0; k < this.select.length; k++) {
          if (this.select[k].index === index && (this.select[k].seat.column !== seatSelect.column || this.select[k].seat.row !== seatSelect.row)) {
            if (this.seats[i][j].column === this.select[k].seat.column && this.seats[i][j].row === this.select[k].seat.row) {
              this.seats[i][j].priority = false;
              this.select = this.select.filter((s, i) => i !== k);
              break;
            }
          }
        }
      }
    }
    this.thirdFormGroup.controls['seats'].setValue(this.seats);
  }

  onRemoveSeat(index: number) {
    this.seatsSelected = this.seatsSelected.filter((s, i) => i !== index);
    let avaibleSeat = this.select.filter((s, i) => s.index === index);
    for (let i = 0; i < this.seats.length; i++) {
      for (let j = 0; j < this.seats[i].length; j++) {
        if (avaibleSeat.length > 0) {
          if (this.seats[i][j].column === avaibleSeat[0].seat.column && this.seats[i][j].row === avaibleSeat[0].seat.row) {
            this.seats[i][j].priority = false;
            this.seats[i][j].type = SeatType.DEFAULT;
            if (this.seatsSelected.length > 0) {
              this.seatsSelected[index].type = SeatType.DEFAULT;
            }
          }
        }
      }
    }
    this.select = this.select.filter((s, i) => s.index !== index);

    for (let i = index; i < this.select.length; i++) {
      this.select[i].index = this.select[i].index - 1;
    }
    this.thirdFormGroup.controls['seats'].setValue(this.seats);
  }

  onSelectTypeSeat(type: any) {
    let avaibleSeat = this.select.filter((s, i) => s.index === type.index);
    for (let i = 0; i < this.seats.length; i++) {
      for (let j = 0; j < this.seats[i].length; j++) {
        if (this.seats[i][j].column === avaibleSeat[0].seat.column && this.seats[i][j].row === avaibleSeat[0].seat.row) {
          this.seats[i][j].type = type.type;
          this.seatsSelected[type.index].type = type.type;
        }
      }
    }
    this.thirdFormGroup.controls['seats'].setValue(this.seats);
  }

  validAddSeat() {
    if(this.thirdFormGroup.disabled){
      return false
    }

    if (this.seats.flat().length === 0 || this.seats.flat().length === this.seatsSelected.length) {
      return false
    }

    if (this.seatsSelected.length > 0) {
      if (this.seatsSelected[this.seatsSelected.length - 1].priority && this.seatsSelected[this.seatsSelected.length - 1].type === SeatType.DEFAULT) {
        return false
      }
    }

    return true
  }

  clone() {
    var seat = {
      priority: true,
      type: SeatType.DEFAULT
    } as CreateSeatDto;
    this.seatsSelected.push(seat);
  }
}
